import { formatSourceCitationDate } from "../../utils/sourceCitationDate";
export const formatPreparationCitation = (author) =>
  [author.name, author.dateLabel].filter(Boolean).join(" · ");
export const getPreparationSourceAuthors = (sourceIds = [], evidence = []) => {
  const selected = new Set(sourceIds);
  const sources = new Map();
  evidence
    .filter(
      (item) =>
        selected.has(`${item.sourceType}:${item.sourceId}`) ||
        selected.has(item.sourceId),
    )
    .flatMap((item) =>
      item.supportingSources?.length ? item.supportingSources : [item],
    )
    .forEach((item) => {
      const key = item.originalSourceRef?.id
        ? `${item.originalSourceRef.type}:${item.originalSourceRef.id}`
        : `${item.sourceType}:${item.sourceId}`;
      if (!sources.has(key))
        sources.set(key, {
          id: item.authorId || null,
          name: item.authorName || "Author not recorded",
          dateLabel: formatSourceCitationDate(
            item.eventDate || item.recordedAt || item.occurredAt,
          ),
          sourceId: item.sourceId,
          sourceType: item.sourceType,
          originalSourceRef: item.originalSourceRef || null,
        });
    });
  return [...sources.values()];
};

export const formatPreparationEvidenceCitation = (item) =>
  getPreparationSourceAuthors([`${item.sourceType}:${item.sourceId}`], [item])
    .map(formatPreparationCitation)
    .join("; ");
